import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TAddress, TBeneficiaryDetails, TBorrowerDetails } from "../types";

export type TMarket = {
  marketName: string;
  marketId: number;
};

export type TBorrowerDetailsNew = {
  marketDetaillsNew: TMarket;
  businessName: string;
  businessType: string;
  shopNum: string;
  shortCode: string;
  businessDesc: string;
  altMobile: string;
  email: string;
  fullName: string;
  mobile: string;
  pan: string;
  dob: string;
  udyamNo: string;
  gender: string;
  address: TAddress;
};

type TinitialState = {
  borrowerDetails: TBorrowerDetails | null;
  beneficiaryDetails: TBeneficiaryDetails | null;
  activeTab: string;
  platformType: string;
  analyseBrwBtnStatus: boolean;
  borrowerDetailsNew: TBorrowerDetailsNew;
  refreshBorrowersEntity: boolean;
  activeCashFinTabTab: string;
};
const initialState: TinitialState = {
  borrowerDetails: null,
  beneficiaryDetails: null,
  activeTab: "All",
  platformType: "",
  analyseBrwBtnStatus: false,
  borrowerDetailsNew: {
    marketDetaillsNew: {
      marketName: "",
      marketId: 0,
    },
    businessName: "",
    businessType: "",
    shopNum: "",
    shortCode: "",
    businessDesc: "",
    altMobile: "",
    email: "",
    fullName: "",
    mobile: "",
    pan: "",
    dob: "",
    udyamNo: "",
    gender: "",
    address: {
      id: 0,
      traderId: 0,
      addressLine: "",
      city: "",
      state: "",
      pincode: "",
      type: "",
      status: 0,
      defaultValue: 0,
      latitude: 0,
      longitude: 0,
    },
  },
  refreshBorrowersEntity: false,
  activeCashFinTabTab: "",
};
const tradeSlice = createSlice({
  name: "borrowers",
  initialState: initialState,
  reducers: {
    updateBorrowerDetails: (
      state,
      action: PayloadAction<{
        borrowerDetails: TBorrowerDetails | null;
      }>,
    ) => {
      state.borrowerDetails = action.payload.borrowerDetails;
    },
    updateBeneficiaryDetails: (
      state,
      action: PayloadAction<{
        beneficiaryDetails: TBeneficiaryDetails | null;
      }>,
    ) => {
      state.beneficiaryDetails = action.payload.beneficiaryDetails;
    },

    UpdateActiveTab: (state, action: PayloadAction<string>) => {
      state.activeTab = action.payload;
    },

    UpdateplatformType: (state, action: PayloadAction<string>) => {
      state.platformType = action.payload;
    },
    setAnalyseBrwBtnStatus: (state, action: PayloadAction<boolean>) => {
      state.analyseBrwBtnStatus = action.payload;
    },
    setBorrowerDetailsNew: (
      state,
      action: PayloadAction<TBorrowerDetailsNew>,
    ) => {
      state.borrowerDetailsNew = action.payload;
    },
    setRefreshBorrowersEntity: (state) => {
      state.refreshBorrowersEntity = !state.refreshBorrowersEntity;
    },
    updateActiveCashFinTabTab: (state, action: PayloadAction<string>) => {
      state.activeCashFinTabTab = action.payload;
    },
  },
});

export const {
  updateBorrowerDetails,
  updateBeneficiaryDetails,
  UpdateActiveTab,
  UpdateplatformType,
  setAnalyseBrwBtnStatus,
  setBorrowerDetailsNew,
  setRefreshBorrowersEntity,
  updateActiveCashFinTabTab,
} = tradeSlice.actions;
export default tradeSlice.reducer;
